import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { TooltipModule } from '../../common/tooltip/tooltip.module';
import { DialogCloseComponent } from './dialog-close.component';

@NgModule({
  imports: [CommonModule, TooltipModule, I18nModule, DialogCloseComponent],
  exports: [DialogCloseComponent],
})
export class DialogCloseModule {}
export { DialogCloseComponent } from './dialog-close.component';
